import DayScreenThemes from './theme/DayScreenTheme';
const bold = require('./assets/fonts/Lfont1212c_L1B.otf');

export default {
  Lexus: {
    Day:{...DayScreenThemes,
      Fonts: {
        bold,
      },},
  },
};

